import { render } from "./ConversationSelectorEntry.vue?vue&type=template&id=3b87a0ea&scoped=true"
import script from "./ConversationSelectorEntry.vue?vue&type=script&lang=js"
export * from "./ConversationSelectorEntry.vue?vue&type=script&lang=js"

import "./ConversationSelectorEntry.vue?vue&type=style&index=0&id=3b87a0ea&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b87a0ea"]])

export default __exports__